export const PERSON_TYPE = {
  PHYSICAL: "F",
  MORAL: "M",
  ANY: "A",
};
